import { createFileRoute, useLocation } from '@tanstack/react-router';
import { SearchHomePage } from '../../features/search/pages/SearchHomePage';

export type SearchNavState = { tabIndex?: number };

export const Route = createFileRoute('/_app/search')({
  component: RouteComponent,
});

function RouteComponent() {
  const location = useLocation();
  const { tabIndex } = (location.state as SearchNavState | undefined) ?? {};
  return <SearchHomePage tabIndex={tabIndex} />;
}
